import { apiBaseUrl } from '../../components/core/globalVariables';

import { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

export default function OAuthCallback () {
  const [error, setError] = useState('')
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const exchangeCode = async () => {
      try {
        const params = new URLSearchParams(window.location.search)

        const code = params.get('code')
        const returnedState = params.get('state')

        const savedState = sessionStorage.getItem('oauth_state')

        const codeVerifier = sessionStorage.getItem('oauth_code_verifier')

        if (!code) {
          throw new Error('No authorization code returned')
        }

        if (!returnedState || returnedState !== savedState) {
          throw new Error('OAuth state mismatch')
        }

        if (!codeVerifier) {
          throw new Error('Missing OAuth code verifier')
        }

        const response = await fetch(`${apiBaseUrl}/oauth/token`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: new URLSearchParams({
            grant_type: 'authorization_code',
            code,
            redirect_uri: 'https://skylarkland.tech/callback',
            // redirect_uri: 'https://map.harrier.land/callback',
            // redirect_uri: 'http://localhost:3000/dev/callback',
            client_id: 'skylark',
            code_verifier: codeVerifier
          })
        })

        if (!response.ok) {
          const text = await response.text()

          throw new Error(`Token exchange failed: ${response.status} ${text}`)
        }

        const data = await response.json()

        const token = data.access_token

        if (!token) {
          throw new Error('No access token returned')
        }

        console.log('OAuth access token received')

        console.log(token)

        localStorage.setItem('token', token)

        sessionStorage.removeItem('oauth_state')

        sessionStorage.removeItem('oauth_code_verifier')

        // Return to the app.
        // React Router's basename="/dev"
        // means this becomes /dev/
        navigate('/', { replace: true })
      } catch (error) {
        console.error('OAuth login failed:', error)

        setError(error instanceof Error ? error.message : 'Login failed')
      }
    }

    exchangeCode()
  }, [navigate])

  if (error) {
    return <div>Login failed: {error}</div>
  }

  return <div>Logging in...</div>
}
